/**
 * @file index.js
 * Exports all hoc components.
 */

import ThemeProvider from './ThemeProvider/ThemeProvider';
import PrivateRoute from './PrivateRoute/PrivateRoute.container';
import PublicRoute from './PublicRoute/PublicRoute.container';

export { ThemeProvider, PrivateRoute, PublicRoute };



// WEBPACK FOOTER //
// ./src/hoc/index.js